<template>
  <div>

    <div  @click="openSide()">
      <slot></slot>
    </div>


    <HeadlessTransitionRoot as="template" :show="open">
      <HeadlessDialog as="div" class="relative z-[100]" @close="open = false">
        <div class="fixed inset-0 bg-black/50 backdrop-blur-sm" />

        <div class="fixed inset-0 overflow-hidden">
          <div class="absolute inset-0 overflow-hidden">
            <div class="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
              <HeadlessTransitionChild as="template" enter="transform transition ease-in-out duration-500 sm:duration-700" enter-from="translate-x-full" enter-to="translate-x-0" leave="transform transition ease-in-out duration-500 sm:duration-700" leave-from="translate-x-0" leave-to="translate-x-full">
                <HeadlessDialogPanel class="pointer-events-auto w-screen max-w-md">
                  <div class="flex h-full flex-col overflow-y-scroll bg-woodsmoke-850 py-6 shadow-xl border-l border-l-white/20">
                    <div class="px-4 sm:px-6">
                      <div class="flex items-start justify-between">
                        <HeadlessDialogTitle class="text-base font-semibold leading-6 text-turquoise-500">Guide: Over the Counter</HeadlessDialogTitle>
                        <div class="ml-3 flex h-7 items-center">
                          <span class="absolute -inset-2.5" />
                          <button type="button" class="relative rounded-md bg-white/10 text-red-500" @click="open = false">
                            <span class="sr-only">Close panel</span>
                            <Icon name="eva:close-fill" class="h-6 w-6" />
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="relative mt-2 flex-1">
                      <div class="border-b px-4 pb-2 border-b-white/20">
                        <div class="w-full grid grid-cols-3 gap-2">
                          <button @click="selectTab(_tab)" v-for="_tab in tabs" :class="['btn btn-sm btn-ghost text-sm w-full h-full rounded-md p-2 font-normal', _tab.selected ? 'bg-white/10 text-white' : '']">{{ _tab.name }}</button>
                        </div>
                      </div>

                      <section v-if="selectedTab.key == 'create'" class="w-full p-4 pt-8 text-woodsmoke-100">
                        <h1 class="text-xl text-white font-light">Create Listing</h1>
                        <p class="text-sm text-woodsmoke-50">Using the OTC, you are able to sell your allocation by create a listing.</p>

                        <br />
                        <br />

                        <p>This guide will focus on explaining the split, refund and fee collection of a listing.</p>

                        <br />

                        <p>For ease of illustration, we will discuss the process using an example, where we attempt to raise allocation for an imaginary project: Oldbull.tech.</p>

                        <br />

                        <p>Assume an allocation of Oldbull.tech that is currently available:</p>

                        <div class="bg-white/5 w-full grid grid-cols-4 p-4 rounded-xl mt-4 justify-center items-center gap-4">
                          <div class="w-full aspect-square rounded-xl overflow-hidden">
                            <img src="/oldbull.png" alt="" />
                          </div>

                          <div class="col-span-3 grid grid-cols-2">
                            <p class="text-sm text-turquoise-500">Project Name</p>
                            <p class="text-sm text-turquoise-500">Allocation</p>
                            <p class="text-woodsmoke-50 text-lg">Oldbull.tech</p>
                            <p class="text-woodsmoke-50 text-lg">500 USDT</p>
                          </div>
                        </div>

                        <div class="text-center text-sm pt-2 text-woodsmoke-300">this is a non-existent, fictional project for the purpose of this guide.</div>

                        <br />

                        <p>An investor, at their discretion, may create a listing utilizing a portion or their entire allocation, with a markup margin of their choice. In this example, said investor has listed their full allocation of 500 USDT, with a 100 USDT markup, resulting in a listing price of 600 USDT:</p>

                        <br />

                        <div class="w-full p-4 bg-white/5 grid grid-cols-6 gap-2 justify-center items-center rounded-xl">
                          <div class="col-span-3">
                            <p class="text-sm text-turquoise-500">Project Name</p>
                            <p class="text-woodsmoke-50 text-lg">Oldbull.tech</p>
                          </div>
                          <div class="col-span-3">
                            <p class="text-sm text-turquoise-500">Allocation</p>
                            <p class="text-woodsmoke-50 text-lg">500 USDT</p>
                          </div>

                          <div class="col-span-full py-2"></div>

                          <div class="col-span-2">
                            <p class="text-sm text-turquoise-500">Price</p>
                            <div class="flex justify-start items-center -ml-1">
                              <p class="text-woodsmoke-50 text-lg bg-white/10 p-1 px-2 rounded-md">600 USDT</p>
                            </div>
                          </div>

                          <div class="col-span-2">
                            <p class="text-sm text-turquoise-500">Markup</p>
                            <p class="text-woodsmoke-50 text-lg">100 USDT</p>
                          </div>

                          <div class="col-span-2">
                            <p class="text-sm text-turquoise-500">Markup %</p>
                            <p class="text-woodsmoke-50 text-lg">20%</p>
                          </div>

                          <p class="col-span-2 text-sm text-woodsmoke-300">(defined by you)</p>
                          <p class="col-span-2 text-sm text-woodsmoke-300">calculated from (600 - 500)</p>
                          <p class="col-span-2 text-sm text-woodsmoke-300">calculated from (100 ÷ 500) x 100%</p>
                        </div>

                        <br />

                        <p>Once the investor has defined a price, the markup and markup % would be automatically computed in the UI.</p>

                        <br />

                        <p>The buyer of your listing will only get the allocation of 500 USDT, even though they need to pay 600 USDT, the price you’ve defined. Please Do note that this allocation is not final due to the existing oversubscribe method, where proportioned refunds will be done in the event of overflowed contribution pool capacity.</p>

                        <br />

                        <p>In such event, allocation would only be partially consumed, hence we would also refund your markup proportionally according to Refund %.</p>
                        <br />

                        <div class="my-4 bg-turquoise-500/5 border border-turquoise-500/10 p-2 px-4 rounded-xl text-turquoise-500">
                          <p class="text-sm mb-1 font-bold">Note</p>
                          <p>Markup refund is splitted according to the refund %.</p>
                        </div>

                        <p>Returning to the earlier example, should the the project raise concludes and effective contribution is 300 USDT, that would give us a refund percentage of 40%.</p>

                        <div class="bg-white/5 my-4 rounded-xl grid grid-cols-6">
                          <div class="col-span-3 p-4">
                            <p class="text-sm text-turquoise-500">Original Allocation</p>
                            <p class="text-woodsmoke-50 text-lg">500 USDT</p>
                          </div>

                          <div class="col-span-3 p-4">
                            <p class="text-sm text-turquoise-500">Effective Contribution</p>
                            <p class="text-woodsmoke-50 text-lg">300 USDT</p>
                          </div>

                          <div class="col-span-full py-1 text-sm bg-white/5 px-4">
                            <p>Results in:</p>
                          </div>

                          <div class="col-span-full flex justify-between items-center px-4 mt-4">
                            <p class="text-sm text-turquoise-500">Unused Allocation (refund)</p>
                            <p class="text-woodsmoke-50 text-lg">200 USDT</p>
                          </div>

                          <div class="col-span-full flex justify-between items-center px-4">
                            <p class="text-sm text-turquoise-500">Refund %</p>
                            <div class="flex justify-start items-center">
                              <p class="text-sm text-woodsmoke-300">(200 ÷ 500) X 100%</p>
                              <p class="text-woodsmoke-50 text-lg ml-4">40 %</p>
                            </div>
                          </div>

                          <div class="col-span-full flex justify-between items-center px-4">
                            <p class="text-sm text-turquoise-500">Markup to Refund (to buyer)</p>
                            <div class="flex justify-start items-center">
                              <p class="text-sm text-woodsmoke-300">(100 USDT x 40%)</p>
                              <p class="text-woodsmoke-50 text-lg ml-4">40 USDT</p>
                            </div>
                          </div>

                          <div class="col-span-full flex justify-between items-center px-4 mb-4">
                            <p class="text-sm text-turquoise-500">Final Markup (your profit)</p>
                            <div class="flex justify-start items-center">
                              <p class="text-sm text-woodsmoke-300">(100 USDT x 60%)</p>
                              <p class="text-woodsmoke-50 text-lg ml-4">60 USDT</p>
                            </div>
                          </div>
                        </div>

                        <p>As illustrated, the markup would then being split according to the refund percentage. In this example the final markup would then be 60 USDT, as only 60% of the intended allocation turns into effective contribution.</p>

                        <br />

                        <h2 class=" mb-4 text-white" >Platform Fee</h2>

                        <p>The final markup earnings shall be subject to a 5% platform fee and the earnings would be credited back to the original listing investor after the project raise concludes.</p>

                        <br>

                        <h2 class=" mb-4 text-white" >Private Sale</h2>

                        <p>On the other hand, a 3% Private Fee would be imposed on top of any Private Sale allocation.</p>

                        <br>

                        <p>This 3% private fee is collected from the buyer. It’s however important for seller to note that the 3% private fee would increase the Listing Price. We’ll take a closer look using the previous oldbull.tech example.</p>


                        <div class="bg-white/5 my-4 rounded-xl grid grid-cols-6">
                          <div class="col-span-3 p-4">
                            <p class="text-sm text-turquoise-500">Original Allocation</p>
                            <p class="text-woodsmoke-50 text-lg">500 USDT</p>
                          </div>

                          <div class="col-span-3 p-4">
                            <p class="text-sm text-turquoise-500">Markup</p>
                            <p class="text-woodsmoke-50 text-lg">100 USDT</p>
                          </div>

                          <div class="col-span-full py-1 text-sm bg-white/5 px-4">
                            <p>Results in:</p>
                          </div>

                          

                          <div class="col-span-full flex justify-between items-center px-4 mt-4">
                            <p class="text-sm text-turquoise-500">Listing Price (before private fee)</p>
                            <div class="flex justify-start items-center">
                              <p class="text-sm text-woodsmoke-300">(500 + 100)</p>
                              <p class="text-woodsmoke-50 text-lg ml-4">600 USDT</p>
                            </div>
                          </div>

                          <div class="col-span-full flex justify-between items-center px-4 ">
                            <p class="text-sm text-turquoise-500">Private Fee</p>
                            <div class="flex justify-start items-center">
                              <p class="text-sm text-woodsmoke-300">(3% x 500)</p>
                              <p class="text-woodsmoke-50 text-lg ml-4">15 USDT</p>
                            </div>
                          </div>

                          <div class="col-span-full flex justify-between items-center px-4 mb-2">
                            <p class="text-sm text-turquoise-500">Final Listing Price</p>
                            <div class="flex justify-start items-center">
                              <p class="text-sm text-woodsmoke-300">(600 + 15)</p>
                              <p class="text-woodsmoke-50 text-lg ml-4">615 USDT</p>
                            </div>
                          </div>

                        </div>

                        <br>
                        <p>While the private fee is refundable, but as the listing investor (Seller), they will only receive markup refunds.</p>
                        <br>


                        <div class="my-4 bg-white/10 p-4 rounded-md">
                          <p class="text-turquoise-500 mb-4">TL;DR</p>

                          <p class="text-woodsmoke-50">An Investor’s markup would be split according to the final effective contribution and refund proportions.</p>
                          <br />
                          <p class="text-woodsmoke-50">Refund proportion is calculated: effective contribution ÷ allocation.</p>
                          <br />
                          <p class="text-woodsmoke-50">Final earnings are subjected to a 5% platform fee. Whilst a 3% private fee would be added on to the investor’s listing allocation and added towards the final listing price for private sale.</p>
                          
                        </div>

                      </section>


                      <section v-if="selectedTab.key == 'buy'" class="w-full p-4 pt-8 text-woodsmoke-100">
                        <h1 class="text-xl text-white font-light">Purchasing a Listing and Contributing</h1>
                        <p class="text-sm text-woodsmoke-50">Using the OTC, you are able to buy and contribute to a project on demand.</p>

                        <br />
                        <br />

                        <p>This guide will explain on the effective contribution, allocation, and refund when purchasing a listing.</p>

                        <br />

                        <p>Using a similar illustration, assume the earlier listing now from the buyer’s perspective in the OTC marketplace:</p>


                        <div class="bg-white/5 w-full grid grid-cols-4 p-4 rounded-xl mt-4 justify-center items-center gap-4">
                          <div class="w-full aspect-square rounded-xl overflow-hidden">
                            <img src="/oldbull.png" alt="" />
                          </div>

                          <div class="col-span-3">

                            <div class="flex justify-between items-center w-full" >
                              <p class="text-sm text-turquoise-500">Project Name</p>
                              <p class="text-woodsmoke-50 text-sm">Oldbull.tech</p>
                            </div>

                            <div class="flex justify-between items-center w-full" >
                              <p class="text-sm text-turquoise-500">Price</p>
                              <p class="text-woodsmoke-50 text-sm">600 USDT</p>
                            </div>

                            <div class="flex justify-between items-center w-full" >
                              <p class="text-sm text-turquoise-500">Allocation</p>
                              <p class="text-woodsmoke-50 text-sm">500 USDT</p>
                            </div>

                            <div class="flex justify-between items-center w-full" >
                              <p class="text-sm text-turquoise-500">Markup</p>
                              <p class="text-woodsmoke-50 text-sm">100 USDT (20%)</p>
                            </div>

                          </div>
                        </div>

                        <div class="text-center text-sm pt-2 text-woodsmoke-300">this is a non-existent, fictional project for the purpose of this guide.</div>

                        <br />

                        <p class="mb-2" >Definition:</p>
                        
                        <p class="text-sm"> <span class="text-white">Price</span>: the price to be paid to purchase this listing</p>
                        <p class="text-sm"> <span class="text-white">Allocation</span>: the allocation an investor will gain upon purchase</p>
                        <p class="text-sm"> <span class="text-white">Markup</span>: The margin difference between the price and allocation</p>

                        <br />

                        <p>Suppose an investor purchased said listing at 600 USDT, the contribution of 500 USDT shall be made directly to the project pool upon purchase.</p>

                        <br />

                        <p>Be sure to differentiate price and allocation, where 500 USDT is the stated allocation, NOT the price.</p>
                        <br />

                        <p>Upon the conclusion of the project, refunds may be issued in the event of oversubscription (oversub). In such cases, only a portion of the allocation will be utilized. Hence, a proportionate refund will be done for any unused allocation along with the markup. The refund percentage will be calculated using the formula (effective contribution ÷ allocation), which will determine the allocation splits.</p>

                        <div class="my-4 bg-turquoise-500/5 border border-turquoise-500/10 p-2 px-4 rounded-xl text-turquoise-500">
                          <p class="text-sm mb-1 font-bold">Note</p>
                          <p>Refunds are splitted according to the refund %.</p>
                        </div>

                        <p>Continuing with our example, suppose that after the project concludes, the effective contribution is 300 USDT, resulting in a refund portion of 40%.</p>

                        <div class="bg-white/5 my-4 rounded-xl grid grid-cols-6">
                          <div class="col-span-3 p-4">
                            <p class="text-sm text-turquoise-500">Original Allocation</p>
                            <p class="text-woodsmoke-50 text-lg">500 USDT</p>
                          </div>

                          <div class="col-span-3 p-4">
                            <p class="text-sm text-turquoise-500">Price</p>
                            <p class="text-woodsmoke-50 text-lg">600 USDT</p>
                          </div>

                          <div class="col-span-3 p-4">
                            <p class="text-sm text-turquoise-500">Original Markup</p>
                            <p class="text-woodsmoke-50 text-lg">100 USDT</p>
                          </div>

                          <div class="col-span-3 p-4">
                            <p class="text-sm text-turquoise-500">Effective Contribution</p>
                            <p class="text-woodsmoke-50 text-lg">300 USDT</p>
                          </div>
                          

                          <div class="col-span-full py-1 text-sm bg-white/5 px-4">
                            <p>Results in:</p>
                          </div>

                          <div class="col-span-full flex justify-between items-center px-4 mt-4">
                            <p class="text-sm text-turquoise-500">Unused Allocation (refund)</p>
                            <p class="text-woodsmoke-50 text-lg">200 USDT</p>
                          </div>

                          <div class="col-span-full flex justify-between items-center px-4">
                            <p class="text-sm text-turquoise-500">Refund %</p>
                            <div class="flex justify-start items-center">
                              <p class="text-sm text-woodsmoke-300">(200 ÷ 500) X 100%</p>
                              <p class="text-woodsmoke-50 text-lg ml-4">40 %</p>
                            </div>
                          </div>

                          <div class="col-span-full flex justify-between items-center px-4">
                            <p class="text-sm text-turquoise-500">Markup to Refund</p>
                            <div class="flex justify-start items-center">
                              <p class="text-sm text-woodsmoke-300">(100 USDT x 40%)</p>
                              <p class="text-woodsmoke-50 text-lg ml-4">40 USDT</p>
                            </div>
                          </div>

                          <div class="col-span-full flex justify-between items-center px-4 mb-4">
                            <p class="text-sm text-turquoise-500">Total Refund</p>
                            <div class="flex justify-start items-center">
                              <p class="text-sm text-woodsmoke-300">(200 USDT + 40 USDT)</p>
                              <p class="text-woodsmoke-50 text-lg ml-4">240 USDT</p>
                            </div>
                          </div>
                        </div>

                        <p>As demonstrated, the markup will be split according to the refund percentage. In this example, the refundable markup is 40 USDT, calculated as 40% of the original markup (100 USDT x 40%). Additionally, the unused allocation of 200 USDT will be refunded, resulting in a total refund of 240 USDT.</p>

                        <br>

                        <h2 class="mb-4 text-white">Private Sale</h2>

                        <div class="my-4 bg-turquoise-500/5 border border-turquoise-500/10 p-2 px-4 rounded-xl text-turquoise-500">
                          <p class="text-sm mb-1 font-bold">Note</p>
                          <p>If the project is raised via Private Sale, a Private Fee 3% would be collected.</p>
                        </div>

                        <p>Similarly, In the event where the project is a Private Sale, a 3% fee is imposed upon the allocation amount.</p>
                        <br>
                        <p>Suppose Oldbull.tech is a Private Sale, the following will happen:</p>
                        <br>
                        <p>1. Allocation will remain the same. (500 USDT)</p>
                        <p>2. Listing price will be increased to 615 USDT (500 USDT + 100 USDT + 15 USDT)</p>

                        <br>

                        <div class="bg-white/5 rounded-xl grid grid-cols-6 py-2">

                          <div class="col-span-full flex justify-between items-center px-4">
                            <p class="text-sm text-turquoise-500">Allocation</p>
                            <div class="flex justify-start items-center">
                              <!-- <p class="text-sm text-woodsmoke-300">(3% X 300 USDT)</p> -->
                              <p class="text-woodsmoke-50 text-lg ml-4">500 USDT</p>
                            </div>
                          </div>

                          <div class="col-span-full flex justify-between items-center px-4">
                            <p class="text-sm text-turquoise-500">Markup </p>
                            <div class="flex justify-start items-center">
                              <!-- <p class="text-sm text-woodsmoke-300">(200 USDT - 9 USDT)</p> -->
                              <p class="text-woodsmoke-50 text-lg ml-4">100 USDT</p>
                            </div>
                          </div>

                          <div class="col-span-full flex justify-between items-center px-4">
                            <p class="text-sm text-turquoise-500">Private Fee</p>
                            <div class="flex justify-start items-center">
                              <p class="text-sm text-woodsmoke-300">(3% X 500 USDT)</p>
                              <p class="text-woodsmoke-50 text-lg ml-4">15 USDT</p>
                            </div>
                          </div>

                          <div class="col-span-full flex justify-between items-center px-4">
                            <p class="text-sm text-turquoise-500">Listing Price (incl. private fee)</p>
                            <div class="flex justify-start items-center">
                              <!-- <p class="text-sm text-woodsmoke-300">(3% X 500 USDT)</p> -->
                              <p class="text-woodsmoke-50 text-lg ml-4">615 USDT</p>
                            </div>
                          </div>

                          <!-- <div class="col-span-full flex justify-between items-center px-4">
                            <p class="text-sm text-turquoise-500">Markup to Refund</p>
                            <div class="flex justify-start items-center">
                              <p class="text-sm text-woodsmoke-300">(100 USDT x 40%)</p>
                              <p class="text-woodsmoke-50 text-lg ml-4">40 USDT</p>
                            </div>
                          </div>

                          <div class="col-span-full flex justify-between items-center px-4 mb-4">
                            <p class="text-sm text-turquoise-500">Total Refund</p>
                            <div class="flex justify-start items-center">
                              <p class="text-sm text-woodsmoke-300">(200 USDT + 40 USDT)</p>
                              <p class="text-woodsmoke-50 text-lg ml-4">240 USDT</p>
                            </div>
                          </div> -->
                        </div>

                        <br>

                        <p>Private Fee is refundable, and follows the same principles. Circling back to our previous example of 40% refund percentage, the refundable private fee will then be 6 USDT.</p>

                        <br>

                        <div class="bg-white/5 rounded-xl grid grid-cols-6 py-2">

<div class="col-span-full flex justify-between items-center px-4">
  <p class="text-sm text-turquoise-500">Private Fee to Refund</p>
  <div class="flex justify-start items-center">
    <p class="text-sm text-woodsmoke-300">(40% X 15 USDT)</p>
    <p class="text-woodsmoke-50 text-lg ml-4">6 USDT</p>
  </div>
</div>

<div class="col-span-full flex justify-between items-center px-4">
  <p class="text-sm text-turquoise-500">Unused Allocation </p>
  <div class="flex justify-start items-center">
    <p class="text-sm text-woodsmoke-300">(as per above)</p>
    <p class="text-woodsmoke-50 text-lg ml-4">200 USDT</p>
  </div>
</div>

<div class="col-span-full flex justify-between items-center px-4">
  <p class="text-sm text-turquoise-500">Markup To Refund</p>
  <div class="flex justify-start items-center">
    <p class="text-sm text-woodsmoke-300">(as per above)</p>
    <p class="text-woodsmoke-50 text-lg ml-4">40 USDT</p>
  </div>
</div>

<div class="col-span-full flex justify-between items-center px-4">
  <p class="text-sm text-turquoise-500">Total Refund</p>
  <div class="flex justify-start items-center">
    <p class="text-sm text-woodsmoke-300">(6 USDT + 200 USDT + 40 USDT)</p>
    <p class="text-woodsmoke-50 text-lg ml-4">246 USDT</p>
  </div>
</div>


</div>

<br>

<p>You might notice the amount of total refund has been increased. This is consistent with the expectation as the listing price has increased initially.</p>



                        <div class="my-4 bg-white/10 p-4 rounded-md">
                          <p class="text-turquoise-500 mb-4">TL;DR</p>

                          <p class="text-woodsmoke-50">Contribution are being made directly upon successful listing purchase.</p>
                          <br />
                          <p class="text-woodsmoke-50">Allocation and listing price is different, contribution amount is based on the indicated allocation in the listing.</p>
                          <br />
                          <p class="text-woodsmoke-50">After a sale concludes, suppose there’s a refund, the investor will receive refund from both unused allocation and markup.</p>
                          <br>
                          <p class="text-woodsmoke-50">If the project is a private sale, a 3% private fee based on allocation amount would be collected and is refundable after the project concludes.</p>
                          
                        </div>



                      </section>
                    </div>
                  </div>
                </HeadlessDialogPanel>
              </HeadlessTransitionChild>
            </div>
          </div>
        </div>
      </HeadlessDialog>
    </HeadlessTransitionRoot>
  </div>
</template>

<script setup>
const open = ref(false);
const openSide = () => {

  if(start.value){
    tabs.value.forEach((t) => (t.selected = t.key == start.value));
  }

  open.value = true;
};

const props = defineProps(["start"])
const { start } = toRefs(props)

const tabs = ref([
  { name: "Create Listing", key: "create", selected: false },
  { name: "Purchase Listing", key: "buy", selected: false },
]);

const selectTab = (tab) => {
  tabs.value.forEach((t) => (t.selected = t.key == tab.key));
};

const selectedTab = computed(() => tabs.value.find((t) => t.selected));


</script>

<style></style>
